import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppUserFeedbackListDataApi(data) {
  return request({
    url: "web/appUserFeedback/listData",
    method: "post",
    data
  });
}
// 导出
export function loadAppUserFeedbackExportDataApi(data) {
  return request({
    url: "web/appUserFeedback/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateAppUserFeedbackApi(data) {
  return request({
    url: "web/appUserFeedback/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initAppUserFeedbackApi(data) {
  return request({
    url: "web/appUserFeedback/init",
    method: "post",
    data
  });
}

// 待回复数量
export function findNoReplyCountByConditionApi(data) {
  return request({
      url: "web/appUserFeedback/findNoReplyCountByCondition",
      method: "post",
      data
  });
}